import {
  BookOpen,
  Briefcase,
  FolderDown,
  Home,
  LayoutTemplate,
  MessageSquare,
  MoreHorizontal,
  Package,
  UserCircle,
  Users,
  Wrench,
} from 'lucide-react';

/** @type {Record<string, import('lucide-react').LucideIcon>} */
export const NAV_ICONS = {
  Package,
  BookOpen,
  FolderDown,
  LayoutTemplate,
  MoreHorizontal,
  Home,
  Wrench,
  Users,
  Briefcase,
  UserCircle,
  MessageSquare,
};
